<template>
  <div class="uc-modal law-modal" style="display: block" @click="close">
    <div class="uc-modal_content uc-message mb-32" @click="keepOpen">
      <div class="modal-header" style="background-color: #4472b4">
        <div class="row">
          <div class="col-md-2">
            <div class="stand-modal_logo m-20">
              <div class="stand-modal_square">
                <div class="law-modal_img" :style="setImage()"></div>
              </div>
            </div>
          </div>
          <div
            class="col-10 offset-1 col-xl-8 offset-xl-0 col-md-8 offset-md-1 offset-sm-1 d-flex align-items-center"
          >
            <h2 style="color: #fff">Magíster en Derecho, LLM UC</h2>
          </div>
        </div>
      </div>
      <div class="uc-message_body mt-20">
        <v-tabs :vertical="vertical" show-arrows>
          <v-tab>Video</v-tab>
          <v-tab>Fotos</v-tab>
          <v-tab>Conoce el programa</v-tab>
          <v-tab>Contacto</v-tab>
          <v-tab-item style="height: 100%; text-align: -webkit-center">
            <v-card
              max-width="720"
              elevation="10"
              style="height: 100%; box-shadow: none"
            >
              <youtube
                video-id="x4vRTltQX00"
                allowfullscreen
                frameborder="0"
                player-width="100%"
                ref="video"
                class="youtube-video"
                style="height: 100%; padding: 5px"
              ></youtube>
            </v-card>
          </v-tab-item>
          <v-tab-item style="text-align: -webkit-center">
            <div>
              <carousel
                :autoplay="true"
                :autoplayTimeout="2000"
                :loop="true"
                :perPage="1"
              >
                <slide
                  v-for="(photo, key) in [
                    'uploads/documentos_compartidos/LLM_1920x1080.jpg',
                  ]"
                  :key="key"
                >
                  <div :style="getImgUrl(`${baseUrl}/${photo}`)"></div>
                </slide>
              </carousel>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <p>
                  El Programa de Magíster en Derecho, LLM UC, te ofrece la
                  oportunidad de construir el programa que mejor se adapte a tus
                  intereses, haciéndote parte de los desafíos actuales del
                  Derecho.
                </p>
                <p>
                  Tanto en el Magíster en Derecho General como en cada una de
                  sus menciones: Derecho Constitucional, Derecho de la Empresa,
                  Derecho Tributario, Derecho Regulatorio y Derecho del Trabajo
                  y Seguridad Social, aprenderás de los mejores profesores, en
                  un programa flexible, de carácter profesional y reconocida
                  excelencia académica.
                </p>
                <ul class="ml-20">
                  <li>Director del programa: Juan Ignacio Piña</li>
                  <li>Grado: Magíster en Derecho</li>
                  <li>Duración del programa: Mínimo 1 año, máximo 3 años.</li>
                  <li>
                    Horario: Lunes a viernes entre las 17:00 y 21:00 horas.
                    Sábado entre las 9:00 y 13:30 horas.
                  </li>
                  <li>
                    Formato del programa: Presencial / Remot: Clases en vivo
                  </li>
                  <li>
                    Sede: Edificio Patio Alameda (Alameda 440) / Sede Apoquindo
                  </li>
                </ul>
                <p class="text-center">
                  Descarga el folleto del programa
                  <a
                    href="https://magisterenderechollm.uc.cl/images/llm/BROCHURE-LLM.pdf"
                    >aquí<i class="uc-icon">launch</i></a
                  >, o desde este QR
                </p>

                <qrcode-vue
                  class="text-center"
                  value="https://magisterenderechollm.uc.cl/images/llm/BROCHURE-LLM.pdf"
                  :size="this.imageHeight * 0.6"
                  margin="1"
                  level="L"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text class="text-center">
                <p class="text-center">
                  Deja tus datos en este QR, o haz clic
                  <a href="https://admision.magisterenderechollm.uc.cl/"
                    >aquí<i class="uc-icon">launch</i>
                  </a>
                </p>
                <qrcode-vue
                  value="https://admision.magisterenderechollm.uc.cl/"
                  :size="this.imageHeight * 0.6"
                  margin="1"
                  level="L"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <div class="rrss">
          <div class="rrss-column">
            <a
              :href="media"
              :key="key"
              style="text-decoration: none"
              target="_blank"
              v-for="(media, key) in {
                web: 'https://magisterenderechollm.uc.cl/es/',
                linkedin:
                  'https://www.linkedin.com/company/96198761/admin/feed/posts/',
              }"
              v-show="media"
            >
              <v-icon right> mdi-{{ key }} </v-icon>
            </a>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <hr class="uc-hr my-32" />
        <div class="row align-items-center">
          <div class="col-md-10 text-right"></div>
          <div class="col-md-2 text-right">
            <a
              href="javascript:void(0)"
              class="uc-link uc-btn btn-inline"
              @click="close"
            >
              Cerrar
              <i class="uc-icon icon-shape--rounded">close</i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import QrcodeVue from "qrcode.vue";

export default {
  components: { Carousel, Slide, QrcodeVue },
  data() {
    return {
      baseUrl: process.env.VUE_APP_REDES_BASE_PATH,
      vertical: window.innerWidth >= 1000 ? true : false,
      windowWidth: window.innerWidth,
      imageHeight: 0,
    };
  },
  methods: {
    getImgUrl(url) {
      return `
        background-image: url('${url}');
        background-position: center;
        background-size: contain;
        height: ${this.imageHeight}px;
        width: 100%;
      `;
    },
    close() {
      this.$parent.$parent.$children[0].$children[0].$refs.live.player.unMute();
      this.$parent.showLLMModal = false;
    },
    setImage() {
      return `
        background-image: url('${process.env.VUE_APP_REDES_BASE_PATH}/uploads/feria/logos/llm_uc_logo.jpeg');
      `;
    },
    closeModal(event) {
      if (event.keyCode === 27) {
        if (this.$parent.showModal) {
          this.$parent.showModal = false;
          return;
        }
        this.close();
      }
    },
    keepOpen(event) {
      event.stopPropagation();
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      this.imageHeight =
        window.document.getElementsByClassName(
          "uc-message_body"
        )[0].childNodes[0].clientHeight;
    },
  },
  mounted() {
    document
      .querySelector(".modal-footer .row .col-md-10")
      .appendChild(document.querySelector("[role='tablist']"));
    document.addEventListener("keyup", this.closeModal);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.imageHeight =
      window.document.getElementsByClassName(
        "uc-message_body"
      )[0].childNodes[0].clientHeight;
  },
  destroyed() {
    document.removeEventListener("keyup", this.closeModal);
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    windowWidth(newWidth) {
      if (newWidth < 1000) {
        this.vertical = false;
      }
      if (newWidth >= 1000) {
        this.vertical = true;
      }
    },
  },
};
</script>

<style lang="sass">
.uc-modal.law-modal
  .uc-modal_content
    width: 95% !important
  .v-tab--active
    background-color: #4472b4
    color: #fff !important
    .uc-icon.mdi
      color: #fff !important
  .v-tabs
    height: 100%
  .v-tabs-items
    overflow-y: auto
    max-height: 100%
  .v-tabs.v-tabs--vertical
    padding-bottom: 0
    .v-tabs-bar
      width: 450px
    .v-tabs-bar__content
      padding: 10px
  .v-tabs-items
    .v-window__container
      height: 95%
  .v-tabs--vertical
    .v-tab
      font-weight: bold
      justify-content: left !important
      max-width: 100% !important
  .v-tabs--vertical
    .v-tab--active
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.75)
      height: 80px !important
  .v-tabs-slider-wrapper
    width: 0px !important
  .v-card__text
    margin: 0

.uc-table-list
  a
    color: rgba(0, 0, 0, 0.54) !important
  a:focus
    outline: 0px solid rgba(1,118,222,.7)

.uc-modal .uc-modal_content
  width: 90% !important

.law-modal .modal-header
  border-top-left-radius: 4px
  border-top-right-radius: 4px
  height: auto
  padding-bottom: 20px

@media (min-width: 1150px)
  .law-modal .modal-header
    height: 150px
    padding-bottom: 0

@media (min-width: 1220px)
  .law-modal .modal-header
    height: 130px
    padding-bottom: 0

.law-modal_logo
  display: inline-block

.law-modal_circle
  background-color: #fff
  border-radius: 50%
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 15px
  margin: auto
  position: relative
  height: 160px
  width: 160px
.uc-modal.law-modal
  .v-tab--active
    background-color: #4472b4
    color: #fff !important
    .uc-icon.mdi
      color: #fff !important
  .uc-modal_content
    height: 100%
    min-height: 600px
    width: 95% !important
  .law-modal .modal-header
    background-color: var(--bg-color)
    border-top-left-radius: 4px
    border-top-right-radius: 4px
    height: auto
    padding-bottom: 20px
  .law-modal .uc-message_body
    height: 100%
    padding-bottom: 148px !important
    padding-left: 48px !important
    padding-right: 48px !important
    padding-top: 250px !important
    position: absolute
    top: 10px
    width: 100%
    .v-tabs
      display: inline-grid
      width: 95%
    .rrss
      display: inline-grid
      position: absolute
      width: 5%
      .rrss-column
        display: grid
        justify-content: center
        a
          padding-bottom: 10px
  .modal-footer
    background-color: #fff
    bottom: 20px
    padding: 0 48px
    position: absolute
    width: 100%
  .youtube-video > iframe
    height: 100%
    width: 100%

.law-modal_img
  background-position: center
  background-repeat: no-repeat
  background-size: contain
  height: 100%
  margin: auto
  width: 90%

#extension_hall
  background-image: url(http://intranetredes.derecho.uc.cl/uploads/documentos_compartidos/centro_de_extension.JPG)
  background-size: cover
  height: 100%
  opacity: 0.25
  margin: -10px
  position: fixed
  width: 100%
</style>
